module.exports = __webpack_public_path__ + "static/media/buscando.4b18dd5d.flr";